import { api } from './client'
import type { QboCompanySummary, QboReference } from './types'

export const companiesApi = {
  list(): Promise<QboCompanySummary[]> {
    return api.get<QboCompanySummary[]>('/companies')
  },

  connectUrl(): Promise<{ url: string }> {
    return api.get<{ url: string }>('/companies/connect-url')
  },

  disconnect(id: string): Promise<void> {
    return api.post<void>(`/companies/${id}/disconnect`)
  },

  /** Powers the Fix-centre reference pickers (customer, item, account, ...). */
  references(id: string, type: string, search?: string): Promise<QboReference[]> {
    return api.get<QboReference[]>(`/companies/${id}/references`, { query: { type, search } })
  },
}
